(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const EW_HEADER_SCROLL=Object.freeze({directionThreshold:4,revealDelayMs:66});
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.announcementBar = document.querySelector('.announcement-bar-section');
      if (this.announcementBar) {
        this.announcementResizeObserver = new ResizeObserver(() => this.setAnnouncementOffset());
        this.announcementResizeObserver.observe(this.announcementBar);
        this.setAnnouncementOffset();
      }

      this.headerBreakpoint=window.matchMedia('(max-width: 990px)');
      this.headerHeightHandler=this.setHeaderHeight.bind(this);
      this.headerBreakpoint.addEventListener('change',this.headerHeightHandler);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, {passive:true});

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setAnnouncementOffset() {
      document.documentElement.style.setProperty('--ew-announcement-offset', `${this.announcementBar.getBoundingClientRect().height}px`);
    }

    disconnectedCallback() {
      this.announcementResizeObserver?.disconnect();
      this.headerBreakpoint?.removeEventListener('change',this.headerHeightHandler);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      cancelAnimationFrame(this.scrollFrame);
      clearTimeout(this.isScrolling);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if(this.scrollFrame)return;
      this.scrollFrame=requestAnimationFrame(()=>{this.scrollFrame=null;this.updateScroll()});
    }

    updateScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      const interactive = this.header.querySelector('header-drawer details[open], details-modal details[open], header-menu details[open]');
      if (interactive || this.predictiveSearch?.isOpen) {this.currentScrollTop=scrollTop;return;}
      if(scrollTop <= this.headerBounds.top){this.header.classList.remove('scrolled-past-header');this.reset();this.currentScrollTop=scrollTop;return;}
      if(Math.abs(scrollTop-this.currentScrollTop)<EW_HEADER_SCROLL.directionThreshold)return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        this.hide();
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          this.reveal();
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, EW_HEADER_SCROLL.revealDelayMs);

          this.hide();
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.reset();
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
